import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcommerce-audit-config-dashboard',
  templateUrl: './mcommerce-audit-config-dashboard.component.html',
  styleUrls: ['./mcommerce-audit-config-dashboard.component.scss']
})
export class McommerceAuditConfigDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
